// @flow
import { system, type Config } from 'styled-system';
import type { TextAlign } from '@rover/design-system/style-dictionary/build/es6/theme';
import { createTransformWithDefault } from './transforms';

export type TextAlignProps = {|
  textAlign?: TextAlign,
|};

const config: Config<TextAlignProps> = {
  textAlign: {
    property: 'textAlign',
    scale: 'textAlign',
    transform: createTransformWithDefault('left'),
  },
};

export default system<TextAlignProps>(config);



// WEBPACK FOOTER //
// ../react-lib/src/styles/styled-system/textAlign.js